import {useEffect,useRef,useState} from 'react';
export type ShopWebContext={category:string;model:string;query:string;collection:boolean;storefront:string;chargingGroup:string};
export type ShopWebRouting={context:ShopWebContext;restore:(context:ShopWebContext)=>void};
type Route={productId:string;cart:boolean};
export function readShopRoute(url:URL){
 const pathname=url.pathname.replace(/^\/shop-ui(?=\/)/,''),q=url.searchParams,match=pathname.match(/^\/product\/([^/]+)\/?$/);
 let productId='';try{productId=match?decodeURIComponent(match[1]):'';}catch{}
 return {route:{productId,cart:pathname==='/cart'},context:{category:q.get('category')||'all',model:q.get('model')||'',query:q.get('q')||'',collection:q.get('browse')==='1',storefront:q.get('store')||'retail',chargingGroup:q.get('charging')||''}};
}
export function shopRouteUrl(route:Route,context:ShopWebContext){
 const q=new URLSearchParams();
 if(typeof window!=='undefined'){const old=new URLSearchParams(location.search);for(const key of ['lang','country'])if(old.get(key))q.set(key,old.get(key)!);}
 if(context.category!=='all')q.set('category',context.category);
 if(context.model)q.set('model',context.model);
 if(context.query)q.set('q',context.query);
 if(context.collection)q.set('browse','1');
 if(context.storefront!=='retail')q.set('store',context.storefront);
 if(context.chargingGroup)q.set('charging',context.chargingGroup);
 const path=route.productId?'/product/'+encodeURIComponent(route.productId):route.cart?'/cart':'/';
 const base=typeof window!=='undefined'&&window.location.pathname.startsWith('/shop-ui/')?'/shop-ui':'';
 return base+path+(q.size?'?'+q:'');
}
export function useShopWebRouting(config?:ShopWebRouting){
 const [route,setRoute]=useState<Route>(()=>config?readShopRoute(new URL(location.href)).route:{productId:'',cart:false});
 const current=useRef(config);current.current=config;
 const initial=useRef(true);
 useEffect(()=>{if(!config)return;const restore=()=>{const parsed=readShopRoute(new URL(location.href));setRoute(parsed.route);current.current?.restore(parsed.context);window.scrollTo(0,0);};restore();window.addEventListener('popstate',restore);return()=>window.removeEventListener('popstate',restore);},[!!config]);
 const contextKey=JSON.stringify(config?.context);
 useEffect(()=>{if(initial.current){initial.current=false;return;}if(!config)return;
  history.replaceState(history.state,'',shopRouteUrl(route,config.context));
 },[contextKey,route.productId,route.cart]);
 const navigate=(next:Route,replace=false)=>{
  const c=current.current;if(!c)return;
  const url=shopRouteUrl(next,c.context),old=location.pathname+location.search;
  if(old!==url){const depth=Number(history.state?.precisionShopDepth)||0;history[replace?'replaceState':'pushState']({...history.state,precisionShopDepth:replace?depth:depth+1},'',url);}
  setRoute(next);window.scrollTo(0,0);
 };
 return {route,navigate,back:()=>{if(Number(history.state?.precisionShopDepth)>0)history.back();else navigate({productId:'',cart:false},true);}};
}
